// src/components/invoices/genererPdfFacture.jsx
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { formatCurrency, formatDate } from '../../utils/formatters';

// Configuration - URL de base pour l'API
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://senoscar.site';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://apps.prod.atlanticds-sn.com/senoscar';


// Fonction pour obtenir l'URL de l'image principale d'un produit
// Remplacez la fonction getMainImageUrl dans GenererPdfFacture.jsx par celle-ci:
const getMainImageUrl = (product) => {
  if (!product.images || product.images.length === 0) {
    return null;
  }

  const mainImage = product.images.find(img => img.mainImage);
  const path = mainImage ? mainImage.path : product.images[0].path;

  // Traiter l'URL correctement selon le format stocké en base
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  return `${API_BASE_URL}/uploads/${path}`;
};

  // Si le chemin commence par "products/"
  // if (path.startsWith('products/')) {
  //   // Garder le chemin tel quel car le FileController est mappé sur /products/...
  //   return `${API_BASE_URL}/${path}`;
  // }

  // Par sécurité, si le format est différent

// Style pour le PDF
const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    padding: 40,
    fontSize: 12,
  },
  header: {
    flexDirection: 'row',
    marginBottom: 40,
  },
  logo: {
    width: 150,
    height: 'auto',
    marginRight: 20,
  },
  companyInfo: {
    flex: 1,
    textAlign: 'right',
    fontSize: 10,
    color: '#333',
  },
  companyName: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  companyAddress: {
    marginBottom: 2,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  dateContainer: {
    alignItems: 'flex-end',
    marginBottom: 20,
  },
  clientSection: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
    backgroundColor: '#e0e0e0',
    padding: 4,
  },
  clientDetails: {
    fontSize: 10,
    marginBottom: 2,
  },
  table: {
    marginBottom: 30,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#b5835a', // Couleur bronze/dorée pour l'en-tête
    color: 'white',
    padding: 5,
    fontSize: 10,
    fontWeight: 'bold',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    textAlign: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    padding: 5,
    fontSize: 10,
  },
  tableCell: {
    padding: 3,
  },
  numCell: {
    width: '5%',
    textAlign: 'center',
  },
  productCell: {
    width: '35%',
  },
  imageCell: {
    width: '15%',
    alignItems: 'center',
  },
  quantityCell: {
    width: '15%',
    textAlign: 'center',
  },
  priceCell: {
    width: '15%',
    textAlign: 'right',
  },
  totalCell: {
    width: '15%',
    textAlign: 'right',
  },
  productImage: {
    width: 40,
    height: 40,
    objectFit: 'contain',
  },
  totalRow: {
    flexDirection: 'row',
    marginTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#dddddd',
    padding: 5,
  },
  netPayableRow: {
    flexDirection: 'row',
    marginTop: 5,
    padding: 5,
    fontWeight: 'bold',
  },
  totalLabel: {
    textAlign: 'left',
    fontWeight: 'bold',
    width: '55%', // Somme des largeurs des 3 premières colonnes (5% + 35% + 15%)
  },
  totalValue: {
    width: '15%',
    textAlign: 'right',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 9,
    color: '#666',
    borderTopWidth: 1,
    borderTopColor: '#dddddd',
    paddingTop: 10,
  },
  separator: {
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    marginTop: 10,
    marginBottom: 10,
  }
});

// Composant principal pour le PDF de facture
const FacturePDF = ({ data, company }) => {
  // Adapter les données de facture au format attendu
  const order = {
    orderNumber: data.invoiceNumber || (data.order ? data.order.orderNumber : 'N/A'),
    orderDate: data.issueDate || (data.order ? data.order.orderDate : new Date().toISOString()),
    partner: data.client || data.partner || {
      name: 'Client',
      address: '',
      email: ''
    },
    items: data.order ? data.order.items : data.items || [],
    totalAmount: data.totalAmount || (data.order ? data.order.totalAmount : 0),
    discountAmount: data.discountAmount || 0
  };

  console.log("Données adaptées:", order);
  console.log('data', data);
  

  // Calcul des totaux
  const totalQuantity = order.items.reduce((sum, item) => sum + item.quantity, 0);
  const totalAmount = order.items.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
  const ttc = data.totalAmount
  const discountAmount = data.discountAmount || 0;


  // Obtenir la date formatée
  const formattedDate = formatDate(order.orderDate);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* En-tête avec logo et informations de l'entreprise */}
        <View style={styles.header}>
          <Image
            src="/senoscar/images/logoSO.png" // Ou "/logos/logo.png" selon le dossier que vous avez créé
            style={styles.logo}
          />
          <View style={styles.companyInfo}>
            <Text style={styles.companyName}>Zone Industrielle, Diamniadio,</Text>
            <Text style={styles.companyAddress}>En Face Du Marché D'intérêt National,</Text>
            <Text style={styles.companyAddress}>Dakar, Sénégal, Tel: +221 78 655 88 88</Text>
          </View>
        </View>

        {/* Titre de la facture et date */}
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 }}>
          <Text style={styles.title}>FACTURE N° {order.orderNumber}</Text>
          <Text>{formattedDate}</Text>
        </View>

        {/* Section client */}
        <View style={styles.clientSection}>
          <Text style={styles.sectionTitle}>CLIENT</Text>
          <Text style={styles.clientDetails}>{order.partner.name}</Text>
          <Text style={styles.clientDetails}>{order.partner.address}</Text>
          {/* <Text style={styles.clientDetails}>Dakar SN</Text> */}
          <Text style={styles.clientDetails}>{order.partner.email || ''}</Text>
        </View>

        {/* Tableau des produits */}
        <View style={styles.table}>
          {/* En-tête du tableau */}
          <View style={styles.tableHeader}>
            <Text style={[styles.tableCell, styles.numCell]}>N°</Text>
            <Text style={[styles.tableCell, styles.productCell]}>PRODUIT</Text>
            <Text style={[styles.tableCell, styles.imageCell]}>IMAGE</Text>
            <Text style={[styles.tableCell, styles.quantityCell]}>QUANTITE</Text>
            <Text style={[styles.tableCell, styles.priceCell]}>PU</Text>
            <Text style={[styles.tableCell, styles.totalCell]}>TOTAL</Text>
          </View>

          {/* Corps du tableau */}
          {order.items.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.tableCell, styles.numCell]}>{index + 1}</Text>
              <Text style={[styles.tableCell, styles.productCell]}>
                {item.product.sku} / {item.product.name}
              </Text>
              <View style={[styles.tableCell, styles.imageCell]}>
                {getMainImageUrl(item.product) && (
                  <Image
                    src={getMainImageUrl(item.product)}
                    style={styles.productImage}
                  />
                )}
              </View>
              <Text style={[styles.tableCell, styles.quantityCell]}>{item.quantity}</Text>
              <Text style={[styles.tableCell, styles.priceCell]}>{formatCurrency(item.unitPrice, false)}</Text>
              <Text style={[styles.tableCell, styles.totalCell]}>{formatCurrency(item.total || (item.quantity * item.unitPrice), false)}</Text>
            </View>
          ))}

          {/* Ligne des totaux - repositionnée comme demandé */}
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>TOTAL</Text>
            <Text style={[styles.tableCell, styles.quantityCell]}>{totalQuantity}</Text>
            <Text style={[styles.tableCell, styles.priceCell]}></Text>
            <Text style={styles.totalCell}>{formatCurrency(totalAmount, false)}</Text>
          </View>

         {
         
         discountAmount && 

         <View style={styles.netPayableRow}>
            <Text style={styles.totalLabel}></Text>
            <Text style={[styles.tableCell, styles.quantityCell]}></Text>
            <Text >Remise : </Text>
            <Text>{formatCurrency(discountAmount, true)}</Text>
          </View>

          }
          
          {/* Ligne du net à payer */}
          <View style={styles.netPayableRow}>
            <Text style={styles.totalLabel}></Text>
            <Text style={[styles.tableCell, styles.quantityCell]}></Text>
            <Text >NET A PAYER : </Text>
            <Text>{formatCurrency(ttc, true)}</Text>
          </View>
        </View>

        {/* Pied de page */}
        <View style={styles.footer}>
          <Text>
            Zone Industrielle, Diamniadio,
            En Face Du Marché D'intérêt National,
            Dakar, Sénégal
          </Text>
          <Text>Tel: +221 78 655 88 88</Text>
        </View>
      </Page>
    </Document>
  );
};

// Composant pour l'aperçu du PDF
const FacturePDFViewer = ({ invoice, company }) => (
  <PDFViewer width="100%" height={600} style={{ border: 'none' }}>
    <FacturePDF data={invoice} company={company} />
  </PDFViewer>
);

// Composant pour le lien de téléchargement du PDF
const FacturePDFDownloadLink = ({ invoice, company }) => (
  <PDFDownloadLink
    document={<FacturePDF data={invoice} company={company} />}
    fileName={`facture_${invoice.invoiceNumber || (invoice.order ? invoice.order.orderNumber : 'facture')}.pdf`}
    style={{
      textDecoration: 'none',
      padding: '10px 15px',
      backgroundColor: '#b5835a',
      color: 'white',
      borderRadius: '4px',
      display: 'inline-block',
    }}
  >
    {({ blob, url, loading, error }) =>
      loading ? 'Préparation du document...' : 'Télécharger la facture'
    }
  </PDFDownloadLink>
);

// Fonction principale pour générer le PDF de facture
const GenererPdfFacture = ({ invoice, company, showPreview = false, onDownload = null }) => {
  console.log("Données reçues:", invoice);

  // Si onDownload est fourni, on retourne juste le lien de téléchargement
  if (onDownload) {
    return (
      <PDFDownloadLink
        document={<FacturePDF data={invoice} company={company} />}
        fileName={`facture_${invoice.invoiceNumber || (invoice.order ? invoice.order.orderNumber : 'facture')}.pdf`}
        style={{ display: 'none' }}
      >
        {({ blob, url, loading, error }) => {
          if (!loading && !error && blob) {
            onDownload(blob);
          } else if (error) {
            console.error("Erreur lors de la génération du PDF:", error);
          }
          return null;
        }}
      </PDFDownloadLink>
    );
  }

  // Sinon, on montre soit l'aperçu, soit le lien de téléchargement
  return (
    <div>
      {showPreview ? (
        <FacturePDFViewer invoice={invoice} company={company} />
      ) : (
        <FacturePDFDownloadLink invoice={invoice} company={company} />
      )}
    </div>
  );
};

export default GenererPdfFacture;